import logs from '../../../features/widget-map-schematic/fixtures/csgo_events_1.json';

const generateMeaningfulEvent = (hasYieldedMeaningfulEvent) =>
    hasYieldedMeaningfulEvent
        ? {
              sentenceChunks: [
                  { text: 'Team Vitality', color: '#d8ae18', options: null },
                  { text: 'won', color: '', options: null },
                  { text: 'Game 3', color: '', options: null },
              ],
          }
        : null;

export default function* generator() {
    let hasYieldedMeaningfulEvent = true;
    // eslint-disable-next-line no-restricted-syntax
    for (const item of logs) {
        const latestMeaningfulEvent = generateMeaningfulEvent(hasYieldedMeaningfulEvent);

        if (hasYieldedMeaningfulEvent) {
            hasYieldedMeaningfulEvent = false;
        }
        yield {
            body: item.message,
            playerPositionsHidden: false,
            latestMeaningfulEvent,
        };
    }
}
